export default function UppercaseFirstLetter(data){
    return data.charAt(0).toUpperCase() + data.slice(1);
}